const updates = [
  { time: '10分钟前', tag: '独家爆料', title: '某顶流艺人深夜密会被拍，经纪人紧急公关回应引热议', hot: true },
  { time: '28分钟前', tag: '视频实锤', title: '吃瓜爆料每日大赛最新投稿：圈内人士实名曝光选秀内幕', hot: true },
  { time: '1小时前', tag: '热搜第一', title: '知名导演涉嫌不当言论，合作方连夜解除合约', hot: true },
  { time: '2小时前', tag: '网友投稿', title: '某综艺节目录制现场发生冲突，工作人员爆料完整经过', hot: false },
  { time: '3小时前', tag: '追踪更新', title: '上周爆出的合约纠纷案最新进展：双方已进入司法程序', hot: false },
  { time: '5小时前', tag: '新瓜速递', title: '女星社交媒体小号被扒，疑似回应近期争议事件', hot: false },
  { time: '7小时前', tag: '深度报道', title: '影视公司内部邮件泄露，揭露出品方背后资本博弈真相', hot: false },
  { time: '9小时前', tag: '行业观察', title: '知名编剧实名举报平台欠薪，多家影视公司被波及调查', hot: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            热点快讯
          </h2>
          <p className="text-sm text-foreground-500">实时追踪全网最新爆料，不错过任何一个瓜</p>
        </div>

        <div className="relative">
          <div className="absolute left-[11px] top-2 bottom-2 w-0.5 bg-primary-200/60"></div>
          <div className="space-y-0">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-5 pb-7 last:pb-0 group">
                <div className={`relative z-10 flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center mt-0.5 transition-colors ${
                  item.hot
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-background-50 border-primary-300 group-hover:border-primary-500'
                }`}>
                  {item.hot && <i className="ri-fire-fill text-background-50 text-[10px]"></i>}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                      item.hot
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed group-hover:text-primary-700 transition-colors cursor-pointer">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 text-center">
          <a href="#updates" className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-100 text-secondary-700 rounded-lg hover:bg-secondary-200 transition-colors text-sm font-medium cursor-pointer">
            <span>查看更多快讯</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}